<template>
    <div>
        <div class="flex p-5 shadow-md">
            <NuxtLink to="/" external>
                <img
                    src="~/assets/images/roastar_logo.svg"
                    class="h-8"
                    width="163"
                    height="32"
                    alt="Roastar Logo"
                />
            </NuxtLink>
        </div>

        <div class="container my-20 text-center">
            <div v-if="browserRedirectUrl">
                Redirecting you to
                <a :href="baseUrl + browserRedirectUrl">
                    {{ baseUrl + browserRedirectUrl }}
                </a>
            </div>

            <template v-else>
                <h1>{{ headingText }}</h1>

                <p class="mt-12">
                    <NuxtLink href="/" class="btn-primary">Go Home</NuxtLink>
                </p>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import { getLegacyQuoteRedirectUrl } from '~/utils/legacyQuote';

const routeParams = useRoute().params;
const { baseUrl } = useRuntimeConfig().public;

const props = defineProps({
    error: Object as () => NuxtError,
});

let browserRedirectUrl: string | null = null;

const legacyQuoteRedirectUrl = getLegacyQuoteRedirectUrl(routeParams.slug);
if (legacyQuoteRedirectUrl) {
    browserRedirectUrl = legacyQuoteRedirectUrl;
}

const headingText = computed(() => {
    return props.error?.statusCode === 404 ? '404 - Page Not Found' : 'Error';
});

onBeforeMount(() => {
    if (browserRedirectUrl) {
        navigateTo(browserRedirectUrl);
    }
});

useHead({
    title: headingText,
});
</script>
